'use client';

import { HeroSlidesSkeleton } from '@/helpers/skeleton/HeroSlidesSkeleton';
import { useGetHeroSlideQuery } from '@/redux/api/componentApi';
import { HeroSlides } from './custom-hero-slider';
import { HeroWithMockup } from './hero-with-mockup';

const Banner = () => {
  const { data, isLoading, isError } = useGetHeroSlideQuery(undefined);

  const { body } = data || {};

  if (isLoading) {
    return (
      <div className="relative h-[400px] w-[100%] overflow-hidden md:h-[500px] lg:h-[600px]">
        <HeroSlidesSkeleton />
      </div>
    );
  }

  if (isError) {
    return <HeroWithMockup />;
  }

  return (
    <div className="h-full w-full overflow-hidden">
      <HeroSlides
        slides={body}
        autoPlay={true}
        interval={7000}
        pageTitle="Rehab Solutions"
        pageUrl="https://rehabsolutionsbd.com/home"
      />
    </div>
  );
};

export default Banner;
